import { IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';

export const styles: IStyles = {
  root: {
    paddingLeft: { xs: pxToRem(20), lg: pxTovW(241) },
    paddingTop: { xs: pxToRem(20), lg: pxTovW(33) },
    paddingBottom: { xs: pxToRem(50), lg: pxTovW(40) },
    paddingRight: { xs: pxToRem(20), lg: pxTovW(241) },
    boxSizing: 'border-box',
    overflowX: 'hidden',
    overflowY: 'hidden',
  },
  assessmentTxt: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: { xs: 'flex-start', md: 'space-between' },
    gap: { xs: pxToRem(22), md: 0 },
  },
  header: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    paddingBottom: { xs: pxToRem(20), md: pxToRem(29), lg: pxTovW(37) },
  },
  inputBox: {
    width: '100%',
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: { xs: 'space-between', md: 'center' },
    gap: { xs: pxToRem(10), md: pxToRem(15), lg: pxTovW(15) },
  },
  inputFeild: {
    display: 'flex',
    height: { xs: pxToRem(50), md: pxToRem(40), lg: pxTovW(56) },
    borderRadius: { xs: pxToRem(10), md: pxToRem(15), lg: pxTovW(15) },
    border: '1px solid #CCE6FE',
    width: { xs: pxToRem(311), lg: pxTovW(457) },
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  searchBox: {
    width: { xs: '100%', md: pxTovW(484), lg: pxTovW(394) },
    marginY: { md: 'auto' },
  },
  sortBox: {
    marginY: { md: 'auto' },
    marginX: { xs: 'auto', md: 0 },
  },
  inputFieldBox: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: { xs: pxToRem(10), md: pxToRem(24), lg: pxTovW(29) },
  },
  // Mirrors the "My GIL Journey" button on the student project dashboard.
  reportsButtonBox: {
    display: 'flex',
    justifyContent: { xs: 'stretch', md: 'flex-end' },
    paddingTop: { xs: pxToRem(16), md: pxToRem(18), lg: pxTovW(20) },
    paddingBottom: { xs: pxToRem(21), md: pxToRem(27), lg: pxTovW(34.5) },
  },
  // Green report pill used across the app ("View Assessment" on reports).
  reportsButton: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(6), md: pxToRem(10), lg: pxTovW(10) },
    width: { xs: '100%', md: 'max-content' },
    height: { xs: pxToRem(45), md: 'auto' },
    minHeight: { md: pxToRem(40), lg: pxTovW(56) },
    paddingX: { xs: pxToRem(20), md: pxToRem(21), lg: pxTovW(24) },
    borderRadius: { xs: pxToRem(10), md: pxToRem(15), lg: pxTovW(15) },
    backgroundColor: '#158D29',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    '&:hover': { backgroundColor: '#127A23' },
  },
  reportsButtonIcon: {
    width: { xs: pxToRem(20), md: pxToRem(22), lg: pxTovW(26) },
    height: { xs: pxToRem(20), md: pxToRem(22), lg: pxTovW(26) },
    objectFit: 'contain',
  },
  robo: {
    width: { xs: '100%', md: pxTovW(581) },
    height: { xs: pxToRem(194), md: pxToRem(123), lg: pxTovW(194) },
    display: 'flex',
  },
};
